import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./Routes/MainRouter";
import Loader from "./Shared/Loader/Loader";

function App() {
  const [spinner, setSpinner] = useState(true);

  useEffect(() => {
    setTimeout(() => setSpinner(false), 1000);
  }, []);

  if (spinner) {
    return <Loader></Loader>;
  }
  return (
    <div>{!spinner && <RouterProvider router={router}></RouterProvider>}</div>
  );
}

export default App;
